import React from "react";
import {
  FaHome,
  FaProductHunt,
  FaShoppingCart,
  FaUserTie,
  FaImages,
  FaTags,
  FaStar,
  FaPercent,
} from "react-icons/fa";

export const LinkItems = [
  { name: "Home", url: "/", icon: <FaHome /> },
  { name: "Products", url: "/products", icon: <FaProductHunt /> },
  { name: "Offers", url: "/offers", icon: <FaPercent /> },
  { name: "Orders", url: "/orders", icon: <FaShoppingCart /> },
  { name: "Categories", url: "/categories", icon: <FaTags />, privilege: "moderate" },
  { name: "Hero Images", url: "/hero-images", icon: <FaImages />, privilege: "moderate" },
  { name: "Reviews", url: "/platform-reviews", icon: <FaStar />, privilege: "moderate" },
  { name: "Users", url: "/admins", icon: <FaUserTie />, privilege: "admin" },
  { name: "Clients", url: "/prestataires", icon: <FaUserTie />, privilege: "prestataire" },
];


export const orderStatusList = [
  { name: "Reject", value: "rejected" },
  { name: "Processing", value: "processing" },
  { name: "Confirmed", value: "confirmed" },                                  
  { name: "Shipped", value: "shipped" },
  { name: "Delivered", value: "delivered" },
];
  
export const domain = process.env.REACT_APP_BACKEND_HOST;
export const auth_url = `${domain}/api/admin/auth`;
export const login_url = `${domain}/api/admin/login`;
export const register_url = `${domain}/api/admin/register`;
export const logout_url = `${domain}/api/admin/logout`;
export const orders_url = `${domain}/api/admin/orders`;
export const update_product_url = `${domain}/api/admin/product/`;
export const products_url = `${domain}/api/products/`;
export const admins_url = `${domain}/api/admin/users/`;
export const single_order_url = `${domain}/api/orders/`;
export const update_order_status = `${domain}/api/admin/order/`;
export const create_new_product = `${domain}/api/admin/product/new`;
export const delete_review = `${domain}/api/admin/product/review/`;
export const categories_url = `${domain}/api/categories`;
export const hero_images_url = `${domain}/api/hero-images`;
export const platform_reviews_url = `${domain}/api/platform-reviews`;
export const all_product_reviews_url = `${domain}/api/products/admin/all-reviews`;
export const delete_product_review_url = `${domain}/api/products/admin/reviews`;
export const settings_url = `${domain}/api/settings`;
export const update_settings_url = `${domain}/api/settings/offer-timer`;
export const register_fcm_url = `${domain}/api/notifications/register`;
export const unregister_fcm_url = `${domain}/api/notifications/unregister`;
